import {
    GET_USER_DATA,
    GET_USER_DATA_SUCCESS,
    GET_USER_DATA_ERROR,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    LOGIN_USER,
    LOGIN_USER_SUCCESS,
    LOGIN_USER_ERROR,
    UPDATE_PROFILE_USER,
    UPDATE_PROFILE_USER_SUCCESS,
    UPDATE_PROFILE_USER_ERROR,
    CHANGE_PASS_USER,
    CHANGE_PASS_USER_SUCCESS,
    CHANGE_PASS_USER_ERROR,
    SET_OBJECT,
} from '../types';
//Axios
import authAxios from '../config/axiosAuth';
import clienteAxios from '../config/axios';
import qs from 'qs';
//Cookie
import Cookie from '../services/CookieService';
import { closeSession } from '../services/AuthService';
import { WaitingMessage, ErrorMessage, SuccessMessage } from '../components/extras/toastMessages';
import Swal from 'sweetalert2';
import jwt_decode from 'jwt-decode';
import { MSG_CHANGE_PASSWORD_SUCCESS, MSG_CHANGING_PASSWORD, MSG_ERROR_SERVER, MSG_LOGIN_IN, MSG_UPDATE_PROFILE_SUCCESS, MSG_UPDATING_PROFILE } from '../constants/messages';

const controller = 'usuario';
const TOKEN_EXPIRATION_MARGIN = 30 * 1000;

//Get user data
export function getUserDataAction() {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( getUserData() );
        //Ejecuto la consutla
        try{
            //Busco el token de usuario
            const token = Cookie.get(process.env.REACT_APP_COOKIE_NAME);
            //Si hay token, debo traer los datos
            if(token){
                //Tengo que decodificar el token
                var decoded = jwt_decode(token);
                // Verifico que el token no esté vencido
                if ( !decoded.exp || decoded.exp * 1000 <= Date.now() + TOKEN_EXPIRATION_MARGIN ) {
                    closeSession();
                    return;
                }
                //Armo los datos
                const data = {
                    accessToken: token,
                    refreshToken: Cookie.get(process.env.REACT_APP_REFRESH_COOKIE_NAME),
                    usuario: decoded.usuario,
                    authorities: decoded.authorities
                }
                //Llamo al success
                dispatch( getUserDataSuccess(data) );
            }else{
                //Debo redireccionar al login
                window.location.href = '/iniciar-sesion';
            }
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( getUserDataError(data) );
        }
    }
}

const getUserData = () => ({
    type: GET_USER_DATA,

})

const getUserDataSuccess = data => ({
    type: GET_USER_DATA_SUCCESS,
    payload: data
})

const getUserDataError = error => ({
    type: GET_USER_DATA_ERROR,
    payload: error
})

//Logout
export function logoutAction(history) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( logout() );
        //Espera
        WaitingMessage('Cerrando sesión');
        //Elimino la cookie y redirecciono
        closeSession();
        //Llamo al success
        dispatch( logoutSuccess() );
        //Oculto la espera
        Swal.close();
    }
}

const logout = () => ({
    type: LOGOUT_USER,

})
//Si el category se guarda ok
const logoutSuccess = () => ({
    type: LOGOUT_USER_SUCCESS,
    payload: null
})

//LOGIN USER
export function loginUserAction(user, history) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( loginUser() );
        //Ejecuto la consutla
        try{
            WaitingMessage(MSG_LOGIN_IN);
            //Armo los parametros
            const data = {
                grant_type: 'password',
                ...user
            }
            //Inicializo la respuesta
            const response = await authAxios.post('/token', qs.stringify(data), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                    'Cache-Control': 'no-cache'
                }
            });
            //Obtengo los datos
            const res = response.data;
            //Guardo la cookie
            Cookie.set(process.env.REACT_APP_COOKIE_NAME, res.access_token, {path: '/', sameSite: 'lax'});
            Cookie.set(process.env.REACT_APP_REFRESH_COOKIE_NAME, res.refresh_token);
            //Decodifico
            const decoded = jwt_decode(res.access_token);
            //Armo los datos
            const userData = {
                accessToken: res.access_token,
                refreshToken: res.refresh_token,
                usuario: decoded.usuario,
                authorities: decoded.authorities
            }
            //Oculto la espera
            Swal.close();
            //Llamo al success
            dispatch( loginUserSuccess(userData) );
            
            //Redirecciono
            // history.push('/');
            // Uso window.location para refrescar la página y así poder recuperar el token almacenado en la cookie ogaToken
            window.location.href = "/";
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( loginUserError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const loginUser = () => ({
    type: LOGIN_USER,

})

const loginUserSuccess = data => ({
    type: LOGIN_USER_SUCCESS,
    payload: data
})

const loginUserError = error => ({
    type: LOGIN_USER_ERROR,
    payload: error
})

//UPDATE PROFILE
export function updateProfileAction(user, callback) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( updateProfile() );
        //Ejecuto la consutla
        try{
            //Muestro la espera
            WaitingMessage(MSG_UPDATING_PROFILE);
            //Hago la consulta
            const responseUser = await clienteAxios.put(`/${controller}/change-profile/`, user);
            //Traigo el token de refresh
            const refreshToken = Cookie.get(process.env.REACT_APP_REFRESH_COOKIE_NAME);
            //Armo los datos
            const dataRequest = {
                grant_type: 'refresh_token',
                refresh_token: refreshToken
            }
            //Inicializo la respuesta
            const response = await authAxios.post('/token', qs.stringify(dataRequest), {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                    'Cache-Control': 'no-cache'
                }
            });
            //Obtengo los datos
            const res = response.data;
            //Guardo la cookie
            Cookie.set(process.env.REACT_APP_COOKIE_NAME, res.access_token, {path: '/', sameSite: 'lax'});
            Cookie.set(process.env.REACT_APP_REFRESH_COOKIE_NAME, res.refresh_token);
            //Decodifico
            const decoded = jwt_decode(res.access_token);
            //Armo los datos
            const userData = {
                accessToken: res.access_token,
                refreshToken: res.refresh_token,
                usuario: decoded.usuario,
                authorities: decoded.authorities
            }
            //Oculto la espera
            Swal.close();
            //Llamo al success
            dispatch( updateProfileSuccess(userData) );
            //Llamo al callback
            callback();
            //Mensaje
            SuccessMessage(MSG_UPDATE_PROFILE_SUCCESS)
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( updateProfileError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const updateProfile = () => ({
    type: UPDATE_PROFILE_USER,

})

const updateProfileSuccess = data => ({
    type: UPDATE_PROFILE_USER_SUCCESS,
    payload: data
})

const updateProfileError = error => ({
    type: UPDATE_PROFILE_USER_ERROR,
    payload: error
})

//CHANGE PASSWORD
export function changePasswordAction(data, callback) {
    return async (dispatch) => {
        //Inicio la ejecución
        dispatch( changePassword() );
        //Ejecuto la consutla
        try{
            //Muestro la espera
            WaitingMessage(MSG_CHANGING_PASSWORD);
            //Hago la consulta
            const responseUser = await clienteAxios.post(`/${controller}/change-password`, data);
            //Inicializo data
            let userData = null;
            //Traigo el token de refresh
            const refreshToken = Cookie.get(process.env.REACT_APP_REFRESH_COOKIE_NAME);
            //Me fijo si existe
            if(refreshToken){
                //Armo los parametros
                const dataRequest = {
                    grant_type: 'refresh_token',
                    refresh_token: refreshToken
                }
                //Inicializo la respuesta
                const response = await authAxios.post('/token', qs.stringify(dataRequest), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        'Cache-Control': 'no-cache'
                    }
                });
                //Obtengo los datos
                const res = response.data;
                //Guardo la cookie
                Cookie.set(process.env.REACT_APP_COOKIE_NAME, res.access_token, {path: '/', sameSite: 'lax'});
                Cookie.set(process.env.REACT_APP_REFRESH_COOKIE_NAME, res.refresh_token);
                //Decodifico
                const decoded = jwt_decode(res.access_token);
                //Armo los datos
                userData = {
                    accessToken: res.access_token,
                    refreshToken: res.refresh_token,
                    usuario: decoded.usuario,
                    authorities: decoded.authorities
                }
            }
            
            //Oculto la espera
            Swal.close();
            //Llamo al success
            dispatch( changePasswordSuccess(userData) );
            //Ejecuto el callback
            callback();
            //Muestro mensaje
            SuccessMessage(MSG_CHANGE_PASSWORD_SUCCESS);
        }catch(error){
            const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response){
                data = response.data;
            }
            //Llamo al dispatch
            dispatch( changePasswordError(data) );
            //Oculto la espera
            Swal.close();
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }
}

const changePassword = () => ({
    type: CHANGE_PASS_USER,
})

const changePasswordSuccess = data => ({
    type: CHANGE_PASS_USER_SUCCESS,
    payload: data
})

const changePasswordError = error => ({
    type: CHANGE_PASS_USER_ERROR,
    payload: error
})


//SET OBJECT
export function setObjectAction(object) {
    return (dispatch) => {
        //Ejecuto el dispatch
        dispatch( setObject(object) );
    }
}

const setObject = data => ({
    type: SET_OBJECT,
    payload: data
})